import * as Types from '../types/types.generated';

import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { useGraphqlFetcher } from '../hooks/useGraphqlFetcher';


export const AllCapabilitiesForUserDocument = `
    query allCapabilitiesForUser {
  allCapabilitiesForUser {
    userId
    capabilities {
      name
      id
    }
  }
}
    `;

export const useAllCapabilitiesForUserQuery = <
      TData = Types.IAllCapabilitiesForUserQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllCapabilitiesForUserQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllCapabilitiesForUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllCapabilitiesForUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllCapabilitiesForUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allCapabilitiesForUser'] : ['allCapabilitiesForUser', variables],
    queryFn: useGraphqlFetcher<Types.IAllCapabilitiesForUserQuery, Types.IAllCapabilitiesForUserQueryVariables>(AllCapabilitiesForUserDocument).bind(null, variables),
    ...options
  }
    )};

export const AllOrganizationDisplaysDocument = `
    query AllOrganizationDisplays($all: String, $offset: Int = 0, $limit: Int = 20, $sortBy: String) {
  allOrganizationDisplays(
    all: $all
    offset: $offset
    limit: $limit
    sortBy: $sortBy
  ) {
    organizations {
      id
      name
    }
    pagination {
      offset
      limit
      total
    }
  }
}
    `;

export const useAllOrganizationDisplaysQuery = <
      TData = Types.IAllOrganizationDisplaysQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllOrganizationDisplaysQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllOrganizationDisplaysQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllOrganizationDisplaysQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllOrganizationDisplaysQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['AllOrganizationDisplays'] : ['AllOrganizationDisplays', variables],
    queryFn: useGraphqlFetcher<Types.IAllOrganizationDisplaysQuery, Types.IAllOrganizationDisplaysQueryVariables>(AllOrganizationDisplaysDocument).bind(null, variables),
    ...options
  }
    )};

export const AllUsersDocument = `
    query allUsers($all: String, $offset: Int = 0, $limit: Int = 20, $sortBy: String) {
  allUsers(all: $all, offset: $offset, limit: $limit, sortBy: $sortBy) {
    users {
      id
      firstName
      lastName
      email
    }
    pagination {
      offset
      limit
      total
    }
  }
}
    `;

export const useAllUsersQuery = <
      TData = Types.IAllUsersQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllUsersQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allUsers'] : ['allUsers', variables],
    queryFn: useGraphqlFetcher<Types.IAllUsersQuery, Types.IAllUsersQueryVariables>(AllUsersDocument).bind(null, variables),
    ...options
  }
    )};

export const CreateFeatureToggleDocument = `
    mutation createFeatureToggle($input: FeatureToggleInput!) {
  createFeatureToggle(input: $input) {
    name
  }
}
    `;

export const useCreateFeatureToggleMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ICreateFeatureToggleMutation, TError, Types.ICreateFeatureToggleMutationVariables, TContext>) => {
    
    return useMutation<Types.ICreateFeatureToggleMutation, TError, Types.ICreateFeatureToggleMutationVariables, TContext>(
      {
    mutationKey: ['createFeatureToggle'],
    mutationFn: useGraphqlFetcher<Types.ICreateFeatureToggleMutation, Types.ICreateFeatureToggleMutationVariables>(CreateFeatureToggleDocument),
    ...options
  }
    )};

export const CreateProgressiveDeliveryConfigDocument = `
    mutation createProgressiveDeliveryConfig($input: CreateProgressiveDeliveryConfigInput!) {
  createProgressiveDeliveryConfig(input: $input) {
    toggleName
    rolloutStages {
      percentage
      durationDays
    }
    currentStageIndex
    status
    assignmentCount
    totalOrgCount
    regionDistribution {
      label
      count
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

export const useCreateProgressiveDeliveryConfigMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ICreateProgressiveDeliveryConfigMutation, TError, Types.ICreateProgressiveDeliveryConfigMutationVariables, TContext>) => {
    
    return useMutation<Types.ICreateProgressiveDeliveryConfigMutation, TError, Types.ICreateProgressiveDeliveryConfigMutationVariables, TContext>(
      {
    mutationKey: ['createProgressiveDeliveryConfig'],
    mutationFn: useGraphqlFetcher<Types.ICreateProgressiveDeliveryConfigMutation, Types.ICreateProgressiveDeliveryConfigMutationVariables>(CreateProgressiveDeliveryConfigDocument),
    ...options
  }
    )};

export const DeleteFeatureToggleDocument = `
    mutation deleteFeatureToggle($input: String!) {
  deleteFeatureToggle(name: $input) {
    name
  }
}
    `;

export const useDeleteFeatureToggleMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IDeleteFeatureToggleMutation, TError, Types.IDeleteFeatureToggleMutationVariables, TContext>) => {
    
    return useMutation<Types.IDeleteFeatureToggleMutation, TError, Types.IDeleteFeatureToggleMutationVariables, TContext>(
      {
    mutationKey: ['deleteFeatureToggle'],
    mutationFn: useGraphqlFetcher<Types.IDeleteFeatureToggleMutation, Types.IDeleteFeatureToggleMutationVariables>(DeleteFeatureToggleDocument),
    ...options
  }
    )};

export const DeleteProgressiveDeliveryConfigDocument = `
    mutation deleteProgressiveDeliveryConfig($toggleName: String!) {
  deleteProgressiveDeliveryConfig(toggleName: $toggleName) {
    toggleName
    status
  }
}
    `;

export const useDeleteProgressiveDeliveryConfigMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IDeleteProgressiveDeliveryConfigMutation, TError, Types.IDeleteProgressiveDeliveryConfigMutationVariables, TContext>) => {
    
    return useMutation<Types.IDeleteProgressiveDeliveryConfigMutation, TError, Types.IDeleteProgressiveDeliveryConfigMutationVariables, TContext>(
      {
    mutationKey: ['deleteProgressiveDeliveryConfig'],
    mutationFn: useGraphqlFetcher<Types.IDeleteProgressiveDeliveryConfigMutation, Types.IDeleteProgressiveDeliveryConfigMutationVariables>(DeleteProgressiveDeliveryConfigDocument),
    ...options
  }
    )};

export const GetFeatureToggleDetailsDocument = `
    query getFeatureToggleDetails($input: String!) {
  getFeatureToggleDetails(name: $input) {
    name
    isEnabled
    category
    clientId
    description
    selectedUsers {
      userId
      fullName
    }
    selectedOrgs {
      orgId
      name
    }
    progressiveDeliveryStatus
    progressiveDeliveryPercentage
    progressiveDeliveryAssignmentCount
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

export const useGetFeatureToggleDetailsQuery = <
      TData = Types.IGetFeatureToggleDetailsQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IGetFeatureToggleDetailsQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetFeatureToggleDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetFeatureToggleDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetFeatureToggleDetailsQuery, TError, TData>(
      {
    queryKey: ['getFeatureToggleDetails', variables],
    queryFn: useGraphqlFetcher<Types.IGetFeatureToggleDetailsQuery, Types.IGetFeatureToggleDetailsQueryVariables>(GetFeatureToggleDetailsDocument).bind(null, variables),
    ...options
  }
    )};

export const GetFeatureTogglesDocument = `
    query getFeatureToggles {
  getFeatureToggles {
    featureToggles {
      name
      isEnabled
      category
      clientId
      description
      progressiveDeliveryStatus
      progressiveDeliveryPercentage
      userCount
      orgCount
      updatedAt
    }
  }
}
    `;

export const useGetFeatureTogglesQuery = <
      TData = Types.IGetFeatureTogglesQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IGetFeatureTogglesQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetFeatureTogglesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetFeatureTogglesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetFeatureTogglesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getFeatureToggles'] : ['getFeatureToggles', variables],
    queryFn: useGraphqlFetcher<Types.IGetFeatureTogglesQuery, Types.IGetFeatureTogglesQueryVariables>(GetFeatureTogglesDocument).bind(null, variables),
    ...options
  }
    )};

export const GetProgressiveDeliveryCalendarDocument = `
    query getProgressiveDeliveryCalendar {
  getProgressiveDeliveryCalendar {
    blackoutDays
    rollouts {
      toggleName
      status
      currentStageIndex
      stageStartedAt
      pausedAt
      rolloutStages {
        percentage
        durationDays
      }
    }
  }
}
    `;

export const useGetProgressiveDeliveryCalendarQuery = <
      TData = Types.IGetProgressiveDeliveryCalendarQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IGetProgressiveDeliveryCalendarQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetProgressiveDeliveryCalendarQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetProgressiveDeliveryCalendarQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetProgressiveDeliveryCalendarQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getProgressiveDeliveryCalendar'] : ['getProgressiveDeliveryCalendar', variables],
    queryFn: useGraphqlFetcher<Types.IGetProgressiveDeliveryCalendarQuery, Types.IGetProgressiveDeliveryCalendarQueryVariables>(GetProgressiveDeliveryCalendarDocument).bind(null, variables),
    ...options
  }
    )};

export const GetProgressiveDeliveryDetailDocument = `
    query getProgressiveDeliveryDetail($toggleName: String!) {
  getProgressiveDeliveryDetail(toggleName: $toggleName) {
    toggleName
    rolloutStages {
      percentage
      durationDays
    }
    currentStageIndex
    stageStartedAt
    pausedAt
    status
    assignmentCount
    totalOrgCount
    regionDistribution {
      label
      count
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

export const useGetProgressiveDeliveryDetailQuery = <
      TData = Types.IGetProgressiveDeliveryDetailQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IGetProgressiveDeliveryDetailQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetProgressiveDeliveryDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetProgressiveDeliveryDetailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetProgressiveDeliveryDetailQuery, TError, TData>(
      {
    queryKey: ['getProgressiveDeliveryDetail', variables],
    queryFn: useGraphqlFetcher<Types.IGetProgressiveDeliveryDetailQuery, Types.IGetProgressiveDeliveryDetailQueryVariables>(GetProgressiveDeliveryDetailDocument).bind(null, variables),
    ...options
  }
    )};

export const GetProgressiveDeliveryListDocument = `
    query getProgressiveDeliveryList {
  getProgressiveDeliveryList {
    toggleName
    currentPercentage
    currentStageIndex
    totalStages
    status
    assignmentCount
    updatedAt
  }
}
    `;

export const useGetProgressiveDeliveryListQuery = <
      TData = Types.IGetProgressiveDeliveryListQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IGetProgressiveDeliveryListQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetProgressiveDeliveryListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetProgressiveDeliveryListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetProgressiveDeliveryListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getProgressiveDeliveryList'] : ['getProgressiveDeliveryList', variables],
    queryFn: useGraphqlFetcher<Types.IGetProgressiveDeliveryListQuery, Types.IGetProgressiveDeliveryListQueryVariables>(GetProgressiveDeliveryListDocument).bind(null, variables),
    ...options
  }
    )};

export const SelfDocument = `
    query self {
  self {
    id
    firstName
    lastName
    email
    phone
    pid
  }
}
    `;

export const useSelfQuery = <
      TData = Types.ISelfQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.ISelfQueryVariables,
      options?: Omit<UseQueryOptions<Types.ISelfQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.ISelfQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.ISelfQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['self'] : ['self', variables],
    queryFn: useGraphqlFetcher<Types.ISelfQuery, Types.ISelfQueryVariables>(SelfDocument).bind(null, variables),
    ...options
  }
    )};

export const SetProgressiveDeliveryBlackoutDaysDocument = `
    mutation setProgressiveDeliveryBlackoutDays($dates: [String!]!) {
  setProgressiveDeliveryBlackoutDays(dates: $dates)
}
    `;

export const useSetProgressiveDeliveryBlackoutDaysMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ISetProgressiveDeliveryBlackoutDaysMutation, TError, Types.ISetProgressiveDeliveryBlackoutDaysMutationVariables, TContext>) => {
    
    return useMutation<Types.ISetProgressiveDeliveryBlackoutDaysMutation, TError, Types.ISetProgressiveDeliveryBlackoutDaysMutationVariables, TContext>(
      {
    mutationKey: ['setProgressiveDeliveryBlackoutDays'],
    mutationFn: useGraphqlFetcher<Types.ISetProgressiveDeliveryBlackoutDaysMutation, Types.ISetProgressiveDeliveryBlackoutDaysMutationVariables>(SetProgressiveDeliveryBlackoutDaysDocument),
    ...options
  }
    )};

export const UpdateFeatureToggleDocument = `
    mutation updateFeatureToggle($input: FeatureToggleInput!) {
  updateFeatureToggle(input: $input) {
    name
  }
}
    `;

export const useUpdateFeatureToggleMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUpdateFeatureToggleMutation, TError, Types.IUpdateFeatureToggleMutationVariables, TContext>) => {
    
    return useMutation<Types.IUpdateFeatureToggleMutation, TError, Types.IUpdateFeatureToggleMutationVariables, TContext>(
      {
    mutationKey: ['updateFeatureToggle'],
    mutationFn: useGraphqlFetcher<Types.IUpdateFeatureToggleMutation, Types.IUpdateFeatureToggleMutationVariables>(UpdateFeatureToggleDocument),
    ...options
  }
    )};

export const UpdateProgressiveDeliveryConfigDocument = `
    mutation updateProgressiveDeliveryConfig($input: UpdateProgressiveDeliveryConfigInput!) {
  updateProgressiveDeliveryConfig(input: $input) {
    toggleName
    rolloutStages {
      percentage
      durationDays
    }
    currentStageIndex
    stageStartedAt
    pausedAt
    status
    assignmentCount
    totalOrgCount
    regionDistribution {
      label
      count
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

export const useUpdateProgressiveDeliveryConfigMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUpdateProgressiveDeliveryConfigMutation, TError, Types.IUpdateProgressiveDeliveryConfigMutationVariables, TContext>) => {
    
    return useMutation<Types.IUpdateProgressiveDeliveryConfigMutation, TError, Types.IUpdateProgressiveDeliveryConfigMutationVariables, TContext>(
      {
    mutationKey: ['updateProgressiveDeliveryConfig'],
    mutationFn: useGraphqlFetcher<Types.IUpdateProgressiveDeliveryConfigMutation, Types.IUpdateProgressiveDeliveryConfigMutationVariables>(UpdateProgressiveDeliveryConfigDocument),
    ...options
  }
    )};
